'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDelete = function TiDelete(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 6.7c-7.4 0-13.3 5.9-13.3 13.3s5.9 13.3 13.3 13.3 13.3-5.9 13.3-13.3-5.9-13.3-13.3-13.3z m6.2 17.1c0.6 0.7 0.6 1.7 0 2.4-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5l-3.8-3.8-3.8 3.8c-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.7-0.6-1.7 0-2.4l3.8-3.8-3.8-3.8c-0.6-0.7-0.6-1.7 0-2.4s1.7-0.6 2.4 0l3.8 3.8 3.8-3.8c0.7-0.6 1.7-0.6 2.4 0s0.6 1.7 0 2.4l-3.8 3.8 3.8 3.8z' })
        )
    );
};

exports.default = TiDelete;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/delete.js
// module id = 2030
// module chunks = 0